import { render, staticRenderFns } from "./WorkshopDetailHeaderCpt.vue?vue&type=template&id=64096f59&scoped=true&"
import script from "./WorkshopDetailHeaderCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopDetailHeaderCpt.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopDetailHeaderCpt.vue?vue&type=style&index=0&id=64096f59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64096f59",
  null
  
)

export default component.exports